import { render, staticRenderFns } from "./HeaderClient.vue?vue&type=template&id=67b0e6e3&scoped=true&"
import script from "./HeaderClient.vue?vue&type=script&lang=js&"
export * from "./HeaderClient.vue?vue&type=script&lang=js&"
import style0 from "./HeaderClient.vue?vue&type=style&index=0&id=67b0e6e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b0e6e3",
  null
  
)

export default component.exports